import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  EditButton,
  DeleteButton,
  ChipField,
  ImageField,
  FunctionField,
  ReferenceField,
} from 'react-admin';

const ProductList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="frontpadProductId" label="Артикул Frontpad" />
      <ImageField source="photos[0]" label="Фото" />
      <TextField source="title" label="Название" />
      <ReferenceField source="categoryId" reference="categories/admin" label="Категория">
        <ChipField source="name" />
      </ReferenceField>
      <NumberField source="price" label="Цена" options={{ style: 'currency', currency: 'RUB' }} />
      <NumberField source="discount" label="Скидка %" />
      <BooleanField source="isAvailable" label="Доступен" />
      <BooleanField source="isVegan" label="Веган" />
      <FunctionField
        label="Теги"
        render={(record: any) => record.tags?.join(', ') || '-'}
      />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export default ProductList;